import { forwardRef, useMemo, useState } from "react";
import { TaleBorderFul } from "@components/TaleBorderFul";

export const TaleInput = forwardRef(
  (
    {
      value,
      onChange,
      width = "100%",
      height = 51,
      role,
      label = "",
      labelClassName = "",
      className = "",
      inputActiveClassName = "",
      errorText = null,
      customBorder = "",
      forceEmptyStyling = false,
      adornment = null,
      suffix = null,
      inputClassName,
      ...props
    },
    ref
  ) => {
    const resolvedRole = role ? role : "normal";
    const [focused, setfocused] = useState(false);
    const sharedStyling = useMemo(
      () =>
        `${
          inputClassName ?? errorText
            ? "bg-white grow"
            : (!focused && !value) || forceEmptyStyling
            ? "bg-[#e8e8e8]"
            : inputActiveClassName ?? "bg-white"
        } transition-all w-full h-full`,
      [
        errorText,
        focused,
        forceEmptyStyling,
        inputActiveClassName,
        inputClassName,
        value,
      ]
    );

    return (
      <div
        className={`flex flex-col ${label ? "gap-1" : ""} ${className ?? ""}`}
      >
        {!label ? null : (
          <span className={`font-semibold text-sm ${labelClassName ?? ""}`}>
            {label}
          </span>
        )}
        <TaleBorderFul
          role={resolvedRole}
          width={width}
          height={height}
          customBackground={
            customBorder ||
            (errorText
              ? "bg-[#E50009]"
              : (!focused && !value) || forceEmptyStyling
              ? "bg-[#e8e8e8]"
              : null)
          }
          className="relative flex"
        >
          <div
            className={`${sharedStyling} flex gap-2 items-center rounded-md px-2 !z-10`}
          >
            {adornment}
            <input
              ref={ref}
              onFocus={() => setfocused(true)}
              onBlur={() => setfocused(false)}
              className={`!z-10 outline-none ${sharedStyling}`}
              value={value}
              onChange={onChange}
              {...props}
            />
            {suffix}
          </div>
          {errorText ? (
            <img
              className="pr-2"
              src="/assets/error.svg"
              alt="Error on input"
            />
          ) : null}
        </TaleBorderFul>
        {errorText ? (
          <span className="text-[#E50009] font-medium text-sm">
            {errorText}
          </span>
        ) : null}
      </div>
    );
  }
);
